// extracted by mini-css-extract-plugin
export default {"text":"PartnersFakedoorModal__text--3WWOL"};